import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40d70287"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed top-0 left-0 m-2" }
const _hoisted_2 = {
  key: 0,
  class: "fixed top-0 left-0 m-2 mt-12"
}
const _hoisted_3 = { class: "bg-gray-100 dark:bg-gray-800 p-2 px-3 rounded-lg my-2" }
const _hoisted_4 = { class: "flex items-center space-x-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-3" }, "Theme", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsIcon = _resolveComponent("SettingsIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        grayTheme: true,
        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.soundEffects('pop');_ctx.isOpen = !_ctx.isOpen})
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SettingsIcon)
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "bounce" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_Switch, {
                    checked: _ctx.isDark,
                    onChange: _ctx.switchTheme
                  }, null, 8, ["checked", "onChange"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}